export function validateProductImageUrl(rawUrl: string): string | null {
  const url = (rawUrl || '').trim();
  if (!url) return 'Enter an image URL';

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return 'Enter a full image URL, starting with https://';
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return 'Only http:// and https:// image URLs can be used';
  }

  return null;
}
